module.exports = __webpack_public_path__ + "static/media/bar.60c440f9.svg";